import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncGetSubCategories() {
    try {
        let response = yield call(API.getSubCategories);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_SUBCATEGORIES,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_SUBCATEGORY,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostSubCategory({ payload }) {
    try {
        let response = yield call(API.postSubCategory, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_SUBCATEGORY,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_SUBCATEGORY,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPutSubCategory({ payload }) {
    try {
        let response = yield call(API.putSubCategory, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_PUT_SUBCATEGORY,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_SUBCATEGORY,
            response: error,
            message: error.message,
        });
    }
}

function* asyncDeleteSubCategory({ payload }) {
    try {
        let response = yield call(API.deleteSubCategory, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_DELETE_SUBCATEGORY,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_SUBCATEGORY,
            response: error,
            message: error.message,
        });
    }
}
export default function* subcategorySaga() {
    yield takeLatest(actionTypes.GET_SUBCATEGORIES, asyncGetSubCategories);
    yield takeLatest(actionTypes.POST_SUBCATEGORY, asyncPostSubCategory);
    yield takeLatest(actionTypes.PUT_SUBCATEGORY, asyncPutSubCategory);
    yield takeLatest(actionTypes.DELETE_SUBCATEGORY, asyncDeleteSubCategory);

}